import { Card } from '../Card';

export const CardList = ({ Header, SubHeader, List }) => (
  <Card>
    <Header />
    <SubHeader />
    <List />
  </Card>
);
